var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4701_563",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4701_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 8.93337L9.93337 10.8667C10.0556 10.9889 10.2112 11.05 10.4 11.05C10.5889 11.05 10.7445 10.9889 10.8667 10.8667C10.9889 10.7445 11.05 10.5889 11.05 10.4C11.05 10.2112 10.9889 10.0556 10.8667 9.93337L8.93337 8.00004L10.8667 6.06671C10.9889 5.94448 11.05 5.78893 11.05 5.60004C11.05 5.41115 10.9889 5.2556 10.8667 5.13337C10.7445 5.01115 10.5889 4.95004 10.4 4.95004C10.2112 4.95004 10.0556 5.01115 9.93337 5.13337L8.00004 7.06671L6.06671 5.13337C5.94448 5.01115 5.78893 4.95004 5.60004 4.95004C5.41115 4.95004 5.2556 5.01115 5.13337 5.13337C5.01115 5.2556 4.95004 5.41115 4.95004 5.60004C4.95004 5.78893 5.01115 5.94448 5.13337 6.06671L7.06671 8.00004L5.13337 9.93337C5.01115 10.0556 4.95004 10.2112 4.95004 10.4C4.95004 10.5889 5.01115 10.7445 5.13337 10.8667C5.2556 10.9889 5.41115 11.05 5.60004 11.05C5.78893 11.05 5.94448 10.9889 6.06671 10.8667L8.00004 8.93337ZM8.00004 14.6667C7.07782 14.6667 6.21115 14.4917 5.40004 14.1417C4.58893 13.7917 3.88337 13.3167 3.28337 12.7167C2.68337 12.1167 2.20837 11.4112 1.85837 10.6C1.50837 9.78893 1.33337 8.92226 1.33337 8.00004C1.33337 7.07782 1.50837 6.21115 1.85837 5.40004C2.20837 4.58893 2.68337 3.88337 3.28337 3.28337C3.88337 2.68337 4.58893 2.20837 5.40004 1.85837C6.21115 1.50837 7.07782 1.33337 8.00004 1.33337C8.92226 1.33337 9.78893 1.50837 10.6 1.85837C11.4112 2.20837 12.1167 2.68337 12.7167 3.28337C13.3167 3.88337 13.7917 4.58893 14.1417 5.40004C14.4917 6.21115 14.6667 7.07782 14.6667 8.00004C14.6667 8.92226 14.4917 9.78893 14.1417 10.6C13.7917 11.4112 13.3167 12.1167 12.7167 12.7167C12.1167 13.3167 11.4112 13.7917 10.6 14.1417C9.78893 14.4917 8.92226 14.6667 8.00004 14.6667Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.3442c279c82d515161c48279b98808eb.svg";
export { ForwardRef as ReactComponent };